import Vue from 'vue'
import VueRouter from 'vue-router'
import shared from "./shared";
import account from "./account";
import checkout from "./checkout";
import egift from "./egift";
import ccards from "./credcards";

import Balance from '../views/account/Balance'
import Menu from "../views/menu/Menu";
import SingleItem from "../views/menu/SingleItem";
import Transaction from "../views/account/Transaction";
import Faqs from "../views/Faqs";

import {fixRoute, guard} from "./helper";

Vue.use(VueRouter)

const routes = [
        ...shared,
        ...account,
        ...checkout,
        ...egift,
        ...ccards,
  {
    path: '/balance',
    name: 'Reward History',
    beforeEnter: guard,
    component: Balance
  },
  {
    path: '/menu/:business_id?',
    name: 'Menu',
    beforeEnter: fixRoute,
    component: Menu
  },
  {
    path: '/menu/:business_id?/menu-item/:id',
    name: 'SingleMenuItem',
    component: SingleItem
  },
  {
    path: '/transaction',
    name: 'Transaction History',
    beforeEnter: guard,
    component: Transaction
  },
  {
    path: '/faqs',
    name: 'Faqs',
    component: Faqs
  }
]

const router = new VueRouter({
  mode: window.cordova ? '' : 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
